// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customSelectField_select_wrap__mVty2 {
  width: calc(50% - 10px);
  max-width: 400px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
  margin-bottom: 20px;
}
.customSelectField_select_wrap__mVty2 select {
  height: 40px;
  width: 100%;
  padding: 10px 18px;
  padding-right: 25px;
  margin-top: 10px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
}

.customSelectField_services_wrap__pA2Xy .customSelectField_service_item__dv\\+8R {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.customSelectField_services_wrap__pA2Xy .customSelectField_service_item__dv\\+8R span {
  width: 90%;
  padding: 5px;
}
.customSelectField_services_wrap__pA2Xy .customSelectField_service_item__dv\\+8R .customSelectField_delete_button__WUTJH {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding: 3px;
  cursor: pointer;
  background-color: var(--secondary-color);
  color: #ffffff;
  font-size: 20px;
  transition: all 0.3s;
}
.customSelectField_services_wrap__pA2Xy .customSelectField_service_item__dv\\+8R .customSelectField_delete_button__WUTJH::after {
  content: "";
  width: 14px;
  height: 3px;
  background-color: #ffffff;
}
.customSelectField_services_wrap__pA2Xy .customSelectField_service_item__dv\\+8R .customSelectField_delete_button__WUTJH:hover::after {
  background: #2e706c;
  transition: all 0.3s;
}
.customSelectField_services_wrap__pA2Xy .customSelectField_service_item__dv\\+8R .customSelectField_delete_button__WUTJH:hover {
  background: var(--green-light);
  transition: all 0.3s;
}

.customSelectField_error_message__MgDth {
  color: red;
  font-size: 12px;
  line-height: 1;
}

@media (max-width: 991px) {
  .customSelectField_select_wrap__mVty2 {
    width: 100% !important;
    max-width: 100%;
  }
  .customSelectField_select_wrap__mVty2 select {
    margin-top: 5px;
    font-size: 16px;
    padding: 8px 15px;
  }
  .customSelectField_service_item__dv\\+8R span {
    font-size: 14px;
  }
  .customSelectField_service_item__dv\\+8R .customSelectField_delete_button__WUTJH {
    width: 17px !important;
    height: 17px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/FormFields/CustomSelectField/customSelectField.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,UAAA;EACA,YAAA;AAAN;AAGI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AADN;AAGM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AADR;AAIM;EACE,mBAAA;EACA,oBAAA;AAFR;AAKM;EACE,8BAAA;EACA,oBAAA;AAHR;;AASA;EACE,UAAA;EACA,eAAA;EACA,cAAA;AANF;;AASA;EACE;IACE,sBAAA;IACA,eAAA;EANF;EAQE;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EANJ;EAWE;IACE,eAAA;EATJ;EAYE;IACE,sBAAA;IACA,uBAAA;EAVJ;AACF","sourcesContent":[".select_wrap {\n  width: calc(50% - 10px);\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 20px;\n\n  select {\n    height: 40px;\n    width: 100%;\n    padding: 10px 18px;\n    padding-right: 25px;\n    margin-top: 10px;\n    border: none;\n    outline: none;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 1;\n  }\n}\n.services_wrap {\n  .service_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n\n    span {\n      width: 90%;\n      padding: 5px;\n    }\n\n    .delete_button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      padding: 3px;\n      cursor: pointer;\n      background-color: var(--secondary-color);\n      color: #ffffff;\n      font-size: 20px;\n      transition: all 0.3s;\n\n      &::after {\n        content: '';\n        width: 14px;\n        height: 3px;\n        background-color: #ffffff;\n      }\n\n      &:hover::after {\n        background: #2e706c;\n        transition: all 0.3s;\n      }\n\n      &:hover {\n        background: var(--green-light);\n        transition: all 0.3s;\n      }\n    }\n  }\n}\n\n.error_message {\n  color: red;\n  font-size: 12px;\n  line-height: 1;\n}\n\n@media (max-width: 991px) {\n  .select_wrap {\n    width: 100% !important;\n    max-width: 100%;\n\n    select {\n      margin-top: 5px;\n      font-size: 16px;\n      padding: 8px 15px;\n    }\n  }\n\n  .service_item {\n    span {\n      font-size: 14px;\n    }\n\n    .delete_button {\n      width: 17px !important;\n      height: 17px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select_wrap": `customSelectField_select_wrap__mVty2`,
	"services_wrap": `customSelectField_services_wrap__pA2Xy`,
	"service_item": `customSelectField_service_item__dv+8R`,
	"delete_button": `customSelectField_delete_button__WUTJH`,
	"error_message": `customSelectField_error_message__MgDth`
};
export default ___CSS_LOADER_EXPORT___;
